import { render, staticRenderFns } from "./market-member-detail.html?vue&type=template&id=2ec6a5ed&scoped=true&external"
import script from "./market-member-detail.js?vue&type=script&lang=js&external"
export * from "./market-member-detail.js?vue&type=script&lang=js&external"
import style0 from "./market-member-detail.scss?vue&type=style&index=0&id=2ec6a5ed&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec6a5ed",
  null
  
)

export default component.exports